import { SaveLocationsDocument } from '~/client/graph/operations/generated/Locations.generated'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import ILocationDto from '~/client/src/shared/types/ILocationDto'

import InteriorPath from '../../models/LocationObjects/InteriorPath'
import LocationStoreBase from './LocationBase.store'

export default class InteriorPathsStore extends LocationStoreBase<InteriorPath> {
  protected saveMutation = SaveLocationsDocument
  protected graphName = 'locations'
  protected defaultIconName = MapViewLocationIcon.InteriorPath

  public get byId(): Map<string, InteriorPath> {
    return this.eventsStore.appState.interiorPaths
  }

  protected fromDto(dto: ILocationDto): InteriorPath {
    return InteriorPath.fromDto(dto)
  }
}
